import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";

import { useStyles } from "../UserTimetable.css";
import { formatTime } from "../../../../Components/FormatTime/FormatTime";

class UserTeacherTimetableBody extends Component {
  render() {
    const { classes, data } = this.props;
    return (
      <Grid item xs={12} sm={12} md={4} lg={4} xl={4}>
        <Paper className={classes.paper}>
          <div>
            {data.studentClass} - {data.section}
          </div>
          {data.faculty && data.group && (
            <div>
              ({data.faculty && data.faculty} - {data.group && data.group})
            </div>
          )}
          <div>{data.subjectName}</div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            {formatTime(data.from)} - {formatTime(data.to)}
          </div>
        </Paper>
      </Grid>
    );
  }
}

export default withStyles(useStyles)(UserTeacherTimetableBody);
